export const classnames = (...stylesheets: Array<string | boolean | undefined | null | object>) =>
  stylesheets
    .flat(Infinity)
    .map(value => (typeof value === 'string' ? value.replace(/  +/g, ' ').trim() : value))
    .filter(value => value !== false)
    .filter(value => value !== undefined && value !== null && value !== '')
    .join(' ')
    .trim();
